import * as React from "react";
import { useState } from "react";
import toast from "react-hot-toast";
import {
  Autocomplete,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FilterOptionsState,
  TextField,
  createFilterOptions,
} from "@mui/material";
import axiosInstant from "../../../../api";
import { ISinglePro } from "../../../../components/singlePro/state";
import CreateProfile from "../../../pro/createEditProfile/CreateProfile";
import ExpertFormHeader from "../../../pro/createEditProfile/ExpertFormHeader";
import { IBrand } from "../../../../types/sharedFormTypes";

interface Props {
  onAddition: (e: IBrand) => void;
}

export const ProductBrandList: React.FC<Props> = ({ onAddition }) => {
  const filter = createFilterOptions<IBrand>();
  const searchInput = React.useRef<string>("");

  const [open, setOpen] = useState(false);
  const [newBrand, setNewBrand] = useState<IBrand>();
  const [loading, setLoading] = useState(false);
  const [brandList, setBrandList] = useState<Array<IBrand>>([]);

  const isBrandExist = (inputValue?: string) =>
    brandList.find((option) => inputValue === option.name);

  const filterOptions = (
    options: Array<IBrand>,
    params: FilterOptionsState<IBrand>
  ) => {
    const { inputValue } = params;
    const filtered = filter(options, params);

    // Suggest the creation of a new value
    const isExisting = isBrandExist(inputValue);
    // if (inputValue !== "" && !isExisting)
    //   filtered.push({ name: `Add "${inputValue}"` });

    return filtered;
  };

  const handleChange = (newValue: IBrand | null) => {
    if (newValue) {
      if (isBrandExist(newValue.name)) onAddition(newValue);
      else {
        const val = { ...newValue };
        val.name = val.name?.slice(5, val.name.length - 1);
        setNewBrand(val);
      }
    }
    searchInput.current = "";
  };

  // const handleNewBrand = (newValue: IBrand | null) => {
  //   if (newValue) onAddition(newValue);
  //   setNewBrand(undefined);
  //   searchInput.current = "";
  // };

  const searchBrands = async () => {
    setLoading(true);
    try {
      const { data: response } = await axiosInstant.get(
        '/brands',
        {
          params: { 
            search: searchInput.current
          },
        }
      );
      setBrandList(response.rows);
    } catch (e) {
      toast.error("Search products error");
    }
    setLoading(false);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    searchInput.current = e.target.value;
    searchBrands();
  };

  React.useEffect(() => {
    if (open) searchBrands();
  }, [open]);

  return (
    <>
      <Autocomplete
        id="asynchronous-demo"
        open={open}
        className="appearance-none text-sm w-full text-text-1 leading-tight focus:outline-accent focus:shadow-outline mb-4 border-border-token"
        value={{ name: searchInput.current }}
        onBlur={() => {
          searchInput.current = "";
        }}
        inputMode="search"
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        isOptionEqualToValue={(option, value) => option.name === value.name}
        getOptionLabel={(option) => option.name || ''}
        options={brandList}
        onChange={(_: any, e: IBrand | null) => handleChange(e)}
        loading={loading}
        filterOptions={filterOptions}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Browse Brands"
            onChange={handleInputChange}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />

      <Dialog
        open={!!newBrand}
        fullWidth
        maxWidth="md"
        onClose={() => setNewBrand(undefined)}
      >
        <ExpertFormHeader create isDialog />
        <DialogContent>
          {/* <CreateProfile isDialog onComplete={handleNewBrand} /> */}
          {/* <BrandForm saveChanges={handleNewBrand} /> */}
        </DialogContent>
      </Dialog>
    </>
  );
};
